<template>
  <div class="container resultView">
    <div>
      <span class="back" @click="back">
        <i class="el-icon-arrow-left"></i> 返回
      </span>
    </div>
    <div class="commonWhiteBg">
      <div class="commonTitle">提交预览</div>
      <div class="MainStepsForm">
        <div class="formWrap">
          <el-form ref="form" label-width="140px">
            <el-form-item label="存证文件" prop="evidenceFile">
              <span v-for="(file, index) in evidenceFile" :key="index"
                >{{ file.sourceName }}
              </span>
            </el-form-item>
            <el-form-item label="取证名称" prop="name">
              {{ subject }}
            </el-form-item>
            <el-form-item label="已上传作品">
              <ul class="commonFileList">
                <li v-for="(item, index) in files" :key="index">
                  <a-icon
                    v-if="
                      item.fileType == 'png' ||
                      item.fileType == 'jpg' ||
                      item.fileType == 'jpeg'
                    "
                    type="file-image"
                  />
                  <a-icon v-if="item.fileType == 'pdf'" type="file-pdf" />
                  <a-icon v-if="item.fileType == 'ppt'" type="file-ppt" />
                  <a-icon
                    v-if="item.fileType == 'docx' || item.filetType == 'doc'"
                    type="file-word"
                  />
                  <a-icon
                    v-if="item.fileType == 'xlsx' || item.fileType == 'xls'"
                    type="file-excel"
                  />
                  <a-icon v-if="item.fileType == 'zip'" type="file-zip" />
                  <span> {{ item.sourceName }}</span>
                </li>
              </ul>
            </el-form-item>
            <el-form-item label="取证相关描述">
              <el-input
                v-model="description"
                :rows="5"
                disabled
                placeholder="请输入您对取证内容的详细描述"
                type="textarea"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="支付方式"
              prop="paymode"
              class="choosePayStyle"
            >
              <el-radio-group v-model="paymode">
                <el-radio :label="1" v-if="paymode == 1">
                  <span class="onlyText"
                    >中国知链会员权益支付（当前存证次数可用{{
                      vipInfo ? vipInfo.obtainCount : 0
                    }}次）</span
                  >
                </el-radio>
                <el-radio :label="2" v-if="paymode == 2">
                  <i class="iconfont aliPayColor"> &#xe634; </i>
                  <span>支付宝支付</span></el-radio
                >
                <!-- <el-radio :label="3" v-if="paymode == 3">
                  <i class="iconfont weChatColor"> &#xe633; </i>
                  <span>微信支付</span></el-radio
                > -->
              </el-radio-group>
            </el-form-item>
            <el-form-item class="submitRow">
              <el-button type="primary" @click="onGoPay">确认并支付</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <pay-dialog ref="payDialog" @close="onSetPayDialogClose"></pay-dialog>
  </div>
</template>

<script>
import PayDialog from "@/views/multipleService/components/PayDialog";
import { applyObtainOrder } from "@/api/ObtainEvidence";
import { mapGetters } from "vuex";
export default {
  name: "",
  components: { PayDialog },
  data() {
    return {
      isPayDialogVisible: false,
      orderInfo: null,
    };
  },
  computed: {
    ...mapGetters(["mid", "userInfo", "evidencePaymentPrice", "vipInfo"]),
  },
  props: {
    subject: String,
    paymode: [String, Number],
    files: Array,
    orderAmount: null,
    evidenceFile: Array, // 存证文件
    description: String,
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      console.log("init result ..");
    },
    back() {
      this.$emit("set-tab-idx", "tab1");
    },
    onGoPay() {
       let that = this;
      if (that.orderInfo) {
        that.$refs.payDialog.showDialog(that.orderInfo);
        that.isPayDialogVisible = true;
        return false;
      }
      let p = "";
      switch (this.paymode) {
        case 1:
          p = "vip";
          break;
        case 2:
          p = "alipay";
          break;
        case 3:
          p = "wechat";
          break;
      }
      let tempFiles = [];
      let evidenceFile = this.evidenceFile;
      this.evidenceFile.map((items) => {
        tempFiles.push({
          ...items,
          itemType: "1",
        });
      });
      this.files.map((items) => {
        tempFiles.push({
          ...items,
          itemType: "2",
        });
      });
      let params = {
        subject: this.subject,
        syncBlockChain: "btc",
        items: tempFiles,
        paymode: p,
        description: this.description,
        currency: "",
      };
      applyObtainOrder(params).then(({ data, res }) => {
        that.orderInfo = data;
        if (data.paymentStatus == "21") {
          that.bus.$emit("refreshVip");
          that.onSetPayDialogClose(true);
        } else {
          that.$refs.payDialog.showDialog(data);
          that.isPayDialogVisible = true;
        }
      });
    },
    onSetPayDialogClose(result) {
      console.log(result);
      if (result) {
        //跳转至详情页
        this.$router.push({
          path: "/ObtainEvidence/Detail",
          query: { orderNo: this.orderInfo.orderNo },
        });
      }
    },
  },
};
</script>

<style lang='scss' scoped>
@import "../../../../../assets/css/inputForm.scss";
</style>
